import React from "react";
import { Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import PremadeScriptView from "./premade-script-view";

const PremadeScriptDialog = ({ open, onClose, premadeId, version }) => {
  return (
    <Modal
      title="Edit Premade Script"
      open={open}
      onCancel={onClose}
      footer={null}
      width="90%"
      style={{ 
        top: "5vh",
        maxWidth: "1400px",
      }}
      styles={{
        body: {
          maxHeight: "85vh",
          padding: 0,
          overflow: "hidden",
        },
      }}
      closeIcon={<CloseOutlined />}
      zIndex={1300}
      getContainer={() => {
        // Find the main content area (excluding sidebar)
        const mainContent = document.querySelector('main[component="main"]') ||
                           document.querySelector('main') ||
                           document.querySelector('.MuiBox-root[component="main"]') ||
                           document.body;
        return mainContent;
      }}
    >
        <PremadeScriptView
          premadeId={premadeId}
          version={version}
          onNavigateBack={onClose}
          isInDialog={true}
        />
    </Modal>
  );
};

export default PremadeScriptDialog;
